import { TenantConfig } from '@bling-fe/shared/tenant-config';

// Main Flink app - allows selecting any tenant (not a tenant itself)
export const MAIN_FLINK_APP = {
  bundleId: 'ch.ce.wink',
  appName: 'Flink'
};

export const FLINK_TENANTS: TenantConfig[] = [
  {
    subdomain: 'abz',
    urls: {
      staging: ['abz.staging.flink.coop'],
      production: ['wink.abz.ch', 'abz.flink.coop']
    },
    nativeApp: { bundleId: 'ch.abz.wink', appName: 'ABZ Wink' }
  },
  {
    subdomain: 'abl',
    urls: {
      staging: ['abl.staging.flink.coop'],
      production: ['app.abl.ch', 'abl.flink.coop']
    },
    nativeApp: { bundleId: 'coop.flink.abl', appName: 'abl-App' }
  },
  {
    subdomain: 'sh',
    urls: {
      staging: ['sh.staging.flink.coop'],
      production: ['app.sunnigehof.ch', 'sh.flink.coop']
    },
    nativeApp: { bundleId: 'coop.flink.sh', appName: 'Sunnige Hof' }
  },
  {
    subdomain: 'bgf',
    urls: {
      staging: ['bgf.staging.flink.coop'],
      production: ['bgf.flink.coop']
    },
    nativeApp: { bundleId: 'coop.flink.bgf', appName: 'myBGF' }
  },
  {
    subdomain: 'maw',
    urls: {
      staging: ['maw.staging.flink.coop'],
      production: ['maw.flink.coop']
    }
  },
  {
    subdomain: 'bdz',
    urls: {
      staging: ['bdz.staging.flink.coop'],
      production: ['bdz.flink.coop']
    }
  },
  {
    subdomain: 'bgle',
    urls: {
      staging: ['bgle.staging.flink.coop'],
      production: ['bgle.flink.coop']
    }
  },
  {
    subdomain: 'ebg',
    urls: {
      staging: ['ebg.staging.flink.coop'],
      production: ['ebg.flink.coop']
    }
  },
  {
    subdomain: 'bsh',
    urls: {
      staging: ['bsh.staging.flink.coop'],
      production: ['bsh.flink.coop']
    }
  },
  {
    subdomain: 'recovery',
    urls: {
      staging: ['recovery.staging.flink.coop'],
      production: ['recovery.flink.coop']
    }
  },
  {
    subdomain: 'bbz',
    urls: {
      staging: ['bbz.staging.flink.coop'],
      production: ['bbz.flink.coop']
    }
  },
  {
    subdomain: 'ig',
    urls: {
      staging: ['ig.staging.flink.coop'],
      production: ['ig.flink.coop']
    }
  },
  {
    subdomain: 'zbwg',
    urls: {
      staging: ['zbwg.staging.flink.coop'],
      production: ['zbwg.flink.coop']
    }
  },
  {
    subdomain: 'vg',
    urls: {
      staging: ['vg.staging.flink.coop'],
      production: ['vg.flink.coop']
    }
  },
  {
    subdomain: 'abau',
    urls: {
      staging: ['abau.staging.flink.coop'],
      production: ['abau.flink.coop']
    }
  },
  {
    subdomain: 'mbgz',
    urls: {
      staging: ['mbgz.staging.flink.coop'],
      production: ['mbgz.flink.coop']
    }
  },
  {
    subdomain: 'lge',
    urls: {
      staging: ['lge.staging.flink.coop'],
      production: ['lge.flink.coop']
    }
  },
  {
    subdomain: 'dan',
    urls: {
      staging: ['dan.staging.flink.coop'],
      production: ['dan.flink.coop']
    }
  },
  {
    subdomain: 'kab',
    urls: {
      staging: ['kab.staging.flink.coop'],
      production: ['kab.flink.coop']
    }
  },
  {
    subdomain: 'bgh',
    urls: {
      staging: ['bgh.staging.flink.coop'],
      production: ['bgh.flink.coop']
    }
  },
  {
    subdomain: 'demo',
    urls: {
      staging: ['demo.staging.flink.coop'],
      production: ['demo.flink.coop']
    }
  },
  {
    // Staging-only test tenant; no production deployment.
    subdomain: 'test',
    urls: {
      staging: ['test.staging.flink.coop'],
      production: []
    }
  }
];
